import { useTheme } from "@mui/material";
import React from "react";

type ButtonProps = {
  to?: string;
  onClick?: () => void;
  secondary?: boolean;
  children: React.ReactNode;
  style?: any;
};

const Button = (props: ButtonProps) => {
  const theme = useTheme();
  const { to, onClick, secondary, children, style } = props;

  const styles = {
    ...theme.typography.button,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0.5rem 1rem",
    borderRadius: "0.7rem",
    background: secondary ? "transparent" : theme.palette.gradient.lightBlue,
    borderColor: secondary ? theme.palette.primary.light : "transparent",
    color: secondary
      ? theme.palette.primary.light
      : theme.palette.text.secondary,
    ...style,
  };

  if (to) {
    return (
      <a href={to} style={styles}>
        {children}
      </a>
    );
  } else if (onClick) {
    return (
      <button onClick={onClick} style={styles}>
        {children}
      </button>
    );
  }

  return <></>;
};

export default Button;
